"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Type of release workflow.
 * @author Radek Beran
 */

var ReleaseWorkflowType;

(function (ReleaseWorkflowType) {
  ReleaseWorkflowType["Regular"] = "Regular";
  ReleaseWorkflowType["Superfast"] = "Superfast";
  ReleaseWorkflowType["Urgent"] = "Urgent";
  ReleaseWorkflowType["Sellout"] = "Sellout";
  ReleaseWorkflowType["SelloutUrgent"] = "SelloutUrgent";
  ReleaseWorkflowType["Simulation"] = "Simulation"; // Note: Emergency release is not part of this application (it is only in external system)
})(ReleaseWorkflowType = exports.ReleaseWorkflowType || (exports.ReleaseWorkflowType = {}));